import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import DemoRequest from "interfaces/howItWorks/DemoRequest";
import { DemoUsageLogRequest } from "interfaces/request/DemoUsageLogRequest";
import {
  getRequestDemoDataAsync,
  getTimePhasedDemoAsync,
  logDemoUsageAsync,
} from "../../apis/DemoApi";
import BaseState from "../../interfaces/state/BaseState";

interface DemoState extends BaseState {
  demoExampleData: any[];
  timePhasedData: any[] | null;
}

const initialState: DemoState = {
  demoExampleData: [],
  timePhasedData: null,
  loading: false,
};

export const getRequestDemoData = createAsyncThunk(
  "demo/getRequestDemoData",
  async (productId: number) => {
    const response = await getRequestDemoDataAsync(productId);
    return response;
  }
);

export const getTimePhasedDemoData = createAsyncThunk(
  "demo/getTimePhasedDemoData",
  async ({
    demoRequest,
    outputKey,
  }: {
    demoRequest: DemoRequest;
    outputKey: string;
  }) => {
    const response = await getTimePhasedDemoAsync(demoRequest);
    return response.timephaseData[outputKey] || [];
  }
);

export const logDemoUsageDataAsync = createAsyncThunk(
  "demo/logDemoUsageDataAsync",
  async (demoUsage: DemoUsageLogRequest) => {
    return await logDemoUsageAsync(demoUsage);
  }
);

export const demoSlice = createSlice({
  name: "demo",
  initialState,
  reducers: {
    resetTimePhasedData: (state) => {
      state.timePhasedData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRequestDemoData.pending, (state) => {
      state.demoExampleData = [];
      state.loading = true;
    });
    builder.addCase(getRequestDemoData.fulfilled, (state, action) => {
      state.loading = false;
      state.demoExampleData = action.payload;
    });
    builder.addCase(getRequestDemoData.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getTimePhasedDemoData.pending, (state) => {
      state.timePhasedData = [];
      state.loading = true;
    });
    builder.addCase(getTimePhasedDemoData.fulfilled, (state, action) => {
      state.loading = false;
      state.timePhasedData = action.payload;
    });
    builder.addCase(getTimePhasedDemoData.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const { resetTimePhasedData } = demoSlice.actions;

export default demoSlice.reducer;
